module.exports = __webpack_public_path__ + "static/media/North-India.2d90f7e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/North-India.jpg
// module id = 1006
// module chunks = 0